'use strict'

import ReportMaterialsGroup from './ReportMaterialsGroup.js'

export default class ReportConsumptionsGroup extends ReportMaterialsGroup {
  hasEqualComplexKeys (record1, record2) {
    if (record1.recId !== record2.recId) {
      return false
    }
    if (record1.projectKey !== record2.projectKey) {
      return false
    }
    if (record1.toolKey !== record2.toolKey) {
      return false
    }
    return true
  }
}
